import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { ContentCard } from "components/ContentCard";
import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import PrimaryButton from "components/Form/Buttons/PrimaryButton";
import openApi from "services/apis/openApi";
import { getPathPrefix } from "utils/coreUtils";

function DataStreamProcess() {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedSchema, setSelectedSchema] = useState();
  const [subscriptionsKey, setSubScriptionsKey] = useState("");
  const [t] = useTranslation();
  const getAllRulesBySubKeys = async (file) => {
    if (!file) {
      return;
    }

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("jsonFile", file);
      formData.append("subscriptionKey", subscriptionsKey);
      const response = await openApi.getAllRulesBySubKey(formData);
      if (response.status === 200) {
        toast.success(t(`statusCodes.PROCESSING_SCHEMA_SUCCESS`));
      } else {
        toast.error(t(`statusCodes.PROCESSING_SCHEMA_ERROR}`));
      }
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  };
  const UploadSchema = () => {
    document.getElementById("fileInput").click();
  };

  const uploadSelectedSchema = () => {
    getAllRulesBySubKeys(selectedSchema);
    setSubScriptionsKey("");
    setSelectedSchema();
  };

  return (
    <>
      <AiccBreadCrumb
        homeLink={getPathPrefix("dashboard")}
        title={t("processingScreen.dataStreamProcessing")}
        items={[{ name: t("processingScreen.dataStreamProcessing") }]}
      />
      <ContentCard
        headerImgSrc="/assets/images/wheel.svg"
        title={t("processingScreen.dataStreamProcessing")}
        bodyContent={
          <div className="row">
            <div className="col-6 col-md-6 justify-content-end">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control "
                  placeholder={t("processingScreen.subscriptionKeyPlaceholder")}
                  value={subscriptionsKey}
                  onChange={(e) => {
                    setSubScriptionsKey(e.target.value);
                  }}
                />
              </div>
            </div>
            <div className="col-6 col-md-6">
              <div className="d-block d-md-flex justify-content-end">
                <PrimaryButton
                  type="button"
                  title={t("processingScreen.upload")}
                  icon="fa-solid fa-upload"
                  className="me-2"
                  onClick={UploadSchema}
                  disabled={!subscriptionsKey}
                />
                <input
                  id="fileInput"
                  type="file"
                  accept=".json"
                  style={{ display: "none" }}
                  value=""
                  onChange={(e) => {
                    e.preventDefault();
                    setSelectedSchema(e.target.files[0]);
                  }}
                />
                <PrimaryButton
                  type="button"
                  title={
                    isLoading
                      ? t("processingScreen.processing")
                      : t("processingScreen.process")
                  }
                  disabled={!selectedSchema || !subscriptionsKey}
                  onClick={uploadSelectedSchema}
                />
              </div>
            </div>
          </div>
        }
      />
    </>
  );
}

export default DataStreamProcess;
